<template>
    <div class="learning-control">
        <div v-if="showControl"
             @click="showLearning"
             class="project-controller-item pointer">
            {{localizeList.learningMode}}
        </div>

        <learning-mode :show="showLearningMode" :learning-info="learningInfo" @hide="hideLearning" />
    </div>
</template>

<script>
    import learningMode from "./learningMode";
    import { bus } from "../../../main"

    export default {
        name: "learningControl",
        components: {
            learningMode
        },
        data() {
            return {
                learningInfo: [],
                trainingInformationLength: 0,
                showLearningMode: false,
                trainingInformationReceived: false,
            }
        },
        computed: {
            showControl() {
                const isBascket = this.$route.fullPath.includes("Basket");
                return isBascket && this.trainingInformationLength
            }
        },
        created() {
            bus.$on("show-learning-mode", () => {
                this.getLearningInfo();
            })
        },
        methods: {
            getLearningInfo() {
                if (this.trainingInformationReceived) return;

                const already = window.localStorage.getItem("learningIsDone");
                const settings = this.$store.getters['getSettings'];
                this.trainingInformationReceived = true;

                if (!settings.EnablingLearningMode) return;

                this.learningInfo = [];

                if (settings.LoginDescription) this.learningInfo.push({text: settings.LoginDescription, type: 0});
                if (settings.TourNameDescription) this.learningInfo.push({text: settings.TourNameDescription, type: 1});
                if (settings.HotelNameDescription) this.learningInfo.push({text: settings.HotelNameDescription, type: 2});
                if (settings.HotelFinesDescription) this.learningInfo.push({text: settings.HotelFinesDescription, type: 3});
                if (settings.MoreFlightDescription) this.learningInfo.push({text: settings.MoreFlightDescription, type: 4});
                if (settings.TariffDescription) this.learningInfo.push({text: settings.TariffDescription, type: 5});
                if (settings.AddServiceDescription) this.learningInfo.push({text: settings.AddServiceDescription, type: 6});
                if (settings.LastNameDescription) this.learningInfo.push({text: settings.LastNameDescription, type: 7});
                if (settings.FirstNameDescription) this.learningInfo.push({text: settings.FirstNameDescription, type: 8});
                if (settings.PassportDescription) this.learningInfo.push({text: settings.PassportDescription, type: 9});
                if (settings.CitizenshipDescription) this.learningInfo.push({text: settings.CitizenshipDescription, type: 10});
                if (settings.PhoneDescription) this.learningInfo.push({text: settings.PhoneDescription, type: 11});
                if (settings.EmailDescription) this.learningInfo.push({text: settings.EmailDescription, type: 12});

                this.trainingInformationLength = this.learningInfo.length;

                if (this.learningInfo.length && already !== "true"){
                    this.showFirstTimeContent();
                    window.localStorage.setItem("learningIsDone", "true");
                }
            },
            showFirstTimeContent() {
                const sayYes = window.confirm(this.localizeList.learningModeFirstTimeText);
                if (sayYes) this.showLearning();
            },
            showLearning() {
                this.showLearningMode = true;
            },
            hideLearning() {
                this.showLearningMode = false;
            }
        }
    }
</script>

<style scoped>
    .project-controller-item {
        padding: 5px 16px;
        margin-left: 16px;
        position: relative;
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        text-decoration: none;
        color: var(--white-color);
    }
    .project-controller-item:before,
    .project-controller-item:after {
        content: "";
        width: 1px;
        height: 60%;
        background-color: var(--white-color);
        position: absolute;
        top: 20%;
    }
    .project-controller-item:after {
        right: 0;
    }
    .project-controller-item:before {
        left: 0;
    }
</style>